'use strict';

var _ = require('lodash');
var ListActionsToolbarController = function ListActionsToolbarController($scope) {
  function swapObjects(collection, index1, index2) {
    var temp = collection[index1];
    collection[index1] = collection[index2];
    collection[index2] = temp;
  }
  function getCollection() {
    return $scope.elementService.getCollection();
  }
  function getSelectedElement() {
    return $scope.elementService.getSelectedElement();
  }
  function getIndexOfSelectedElement() {
    return getCollection().indexOf(getSelectedElement());
  }
  function isAnyElementSelected() {
    return getCollection() && getIndexOfSelectedElement() !== -1;
  }
  function isItemDuplicable() {
    return $scope.elementService.isDuplicable && $scope.elementService.isDuplicable();
  }
  function addElement(element) {
    var collection = getCollection();
    var insertionIndex = isAnyElementSelected() ? getIndexOfSelectedElement() + 1 : collection.length;
    collection.splice(insertionIndex, 0, element);
    $scope.elementService.selectElement(element);
  }
  $scope.addElementAvailable = function () {
    return $scope.addButtonVisible;
  };
  $scope.addNewElement = function () {
    // if the hook is defined, invoke it; if it returned false, skip adding new element
    if ($scope.elementService.preAddingNewElementHook) {
      if (!$scope.elementService.preAddingNewElementHook()) {
        return;
      }
    }
    var collection = getCollection();
    var insertionIndex = isAnyElementSelected() ? getIndexOfSelectedElement() + 1 : collection.length;
    var newObject = $scope.elementService.createNewElement();
    collection.splice(insertionIndex, 0, newObject);
    $scope.elementService.selectElement(newObject);
  };
  $scope.removeElementAvailable = function () {
    return isAnyElementSelected() && (getCollection().length > 1 || $scope.allowEmptyCollection || $scope.clearFirstElement && $scope.elementService.getSelectedRowType() !== null);
  };
  $scope.removeElement = function () {
    if ($scope.removeElementAvailable()) {
      var collection = getCollection();
      var index = getIndexOfSelectedElement();
      var removedElement = _.cloneDeep(getSelectedElement());
      var isLastElement = index === collection.length - 1;
      var newSelectedObject = collection[isLastElement ? index - 1 : index + 1];
      collection.splice(index, 1);
      $scope.elementService.selectElement(newSelectedObject);
      if ($scope.elementService.postRemovingElementHook) {
        $scope.elementService.postRemovingElementHook(removedElement);
      }
      if ($scope.clearFirstElement && collection.length === 0) {
        $scope.addNewElement();
      }
    } else {
      throw new Error('Not allowed operation');
    }
  };
  $scope.moveUpElementAvailable = function () {
    return isAnyElementSelected() && getIndexOfSelectedElement() > 0;
  };
  $scope.moveUpElement = function () {
    if ($scope.moveUpElementAvailable()) {
      var index = getIndexOfSelectedElement();
      swapObjects(getCollection(), index, index - 1);
    } else {
      throw new Error('Not allowed operation');
    }
  };
  $scope.moveDownElementAvailable = function () {
    return isAnyElementSelected() && getIndexOfSelectedElement() < getCollection().length - 1;
  };
  $scope.moveDownElement = function () {
    if ($scope.moveDownElementAvailable()) {
      var index = getIndexOfSelectedElement();
      swapObjects(getCollection(), index, index + 1);
    } else {
      throw new Error('Not allowed operation');
    }
  };
  $scope.isItemToDuplicateAvailable = function () {
    return isItemDuplicable() && isAnyElementSelected();
  };
  $scope.duplicateItem = function () {
    var element = getSelectedElement();
    if (!element) {
      return;
    }
    var clone = $scope.elementService.createCopyOf(element);
    if (clone) {
      addElement(clone);
    }
  };
};
ListActionsToolbarController.$inject = ['$scope'];
module.exports = ListActionsToolbarController;